import { render, staticRenderFns } from "./CardTileOffice.vue?vue&type=template&id=8a6bc544&scoped=true&"
import script from "./CardTileOffice.vue?vue&type=script&lang=ts&"
export * from "./CardTileOffice.vue?vue&type=script&lang=ts&"
import style0 from "./CardTileOffice.vue?vue&type=style&index=0&id=8a6bc544&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6bc544",
  null
  
)

export default component.exports